import { useContext } from 'react';

import { MinMaxConfigContext } from '../context/MinMaxConfigContext.js';

export const useMinMaxConfig = () => useContext(MinMaxConfigContext);
